import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fccdc0b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "card-global text-gray-800" }
const _hoisted_3 = { class: "block-title" }
const _hoisted_4 = {
  for: "constructor",
  class: "input-form-label mt-5"
}
const _hoisted_5 = {
  value: 0,
  disabled: "",
  selected: ""
}
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "space-y-8"
}
const _hoisted_8 = { class: "card-global text-gray-800" }
const _hoisted_9 = { class: "block-title" }
const _hoisted_10 = {
  key: 1,
  class: "input-form-error-text"
}
const _hoisted_11 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_17 = {
  key: 2,
  class: "border-t border-gray-200 pt-6 mt-6 space-y-4"
}
const _hoisted_18 = { class: "text-xl" }
const _hoisted_19 = {
  for: "esedo-document-type",
  class: "input-form-label mt-5"
}
const _hoisted_20 = { value: null }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  for: "esedo-question-nature",
  class: "input-form-label mt-5"
}
const _hoisted_23 = { value: null }
const _hoisted_24 = ["value"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  for: "esedo-partners",
  class: "input-form-label mt-5"
}
const _hoisted_27 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_28 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_29 = {
  key: 0,
  class: "card-global space-y-8 text-gray-800"
}
const _hoisted_30 = { class: "block-title w-1/2" }
const _hoisted_31 = { class: "document-source-tabs" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "input-form-label mt-5" }
const _hoisted_34 = {
  value: "",
  disabled: ""
}
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_37 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_38 = { class: "text-xl" }
const _hoisted_39 = {
  key: 2,
  class: "mt-6 space-y-4 rounded border border-gray-200 p-4"
}
const _hoisted_40 = { class: "text-xl" }
const _hoisted_41 = { class: "input-form-label" }
const _hoisted_42 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = ["onUpdate:modelValue"]
const _hoisted_47 = { value: "" }
const _hoisted_48 = ["value"]
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = {
  key: 6,
  class: "input-form-error-text"
}
const _hoisted_51 = { class: "mt-6 flex flex-wrap gap-3" }
const _hoisted_52 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 1,
  class: "input-form-error-text"
}
const _hoisted_56 = { class: "space-y-2" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 1,
  class: "card-global space-y-8 text-gray-800"
}
const _hoisted_60 = { class: "block-title" }
const _hoisted_61 = { class: "document-source-tabs" }
const _hoisted_62 = {
  key: 1,
  class: "card-global py-20 space-y-8 text-gray-800"
}
const _hoisted_63 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_64 = { class: "input-form-label mt-5" }
const _hoisted_65 = {
  value: "",
  disabled: ""
}
const _hoisted_66 = ["value"]
const _hoisted_67 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_68 = { class: "input-form-label mt-5" }
const _hoisted_69 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_70 = {
  key: 0,
  class: "space-y-4 rounded border border-gray-200 p-4"
}
const _hoisted_71 = { class: "text-xl" }
const _hoisted_72 = { class: "input-form-label" }
const _hoisted_73 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_74 = ["onUpdate:modelValue"]
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = ["onUpdate:modelValue"]
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = { value: "" }
const _hoisted_79 = ["value"]
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = {
  key: 6,
  class: "input-form-error-text"
}
const _hoisted_82 = { class: "flex flex-wrap gap-3" }
const _hoisted_83 = {
  key: 4,
  class: "input-form-error-text"
}
const _hoisted_84 = {
  key: 5,
  class: "space-y-2"
}
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "card-global space-y-8 text-gray-800" }
const _hoisted_88 = { class: "block-title" }
const _hoisted_89 = { key: 2 }
const _hoisted_90 = {
  key: 0,
  class: "card-global mb-8 text-gray-800"
}
const _hoisted_91 = { class: "mb-4 text-sm text-gray-500" }
const _hoisted_92 = { class: "flex items-center justify-between gap-4" }
const _hoisted_93 = { class: "block-title" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2" }
const _hoisted_96 = { class: "input-form-label mt-5" }
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "input-form-label mt-5" }
const _hoisted_99 = ["value"]
const _hoisted_100 = ["value"]
const _hoisted_101 = {
  key: 2,
  class: "input-form-error-text"
}
const _hoisted_102 = { class: "input-form-label mt-5" }
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = {
  key: 0,
  class: "mt-5 flex items-center gap-3"
}
const _hoisted_105 = ["onUpdate:modelValue"]
const _hoisted_106 = { class: "input-form-label mb-0" }
const _hoisted_107 = {
  key: 0,
  class: "space-y-4 text-gray-700"
}
const _hoisted_108 = {
  key: 0,
  class: "rounded border border-amber-200 bg-amber-50 px-4 py-3"
}
const _hoisted_109 = { key: 1 }
const _hoisted_110 = { class: "mb-2 font-medium" }
const _hoisted_111 = { class: "divide-y divide-gray-200 rounded border border-gray-200" }
const _hoisted_112 = { class: "font-medium text-gray-900" }
const _hoisted_113 = { class: "mt-1 break-words text-sm" }
const _hoisted_114 = { class: "text-gray-500" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mx-2",
  "aria-hidden": "true"
}, "→", -1))
const _hoisted_116 = { class: "text-gray-900" }
const _hoisted_117 = { class: "mb-3 text-gray-700" }
const _hoisted_118 = { class: "mb-6 text-sm text-gray-500" }
const _hoisted_119 = { class: "flex flex-wrap gap-3" }
const _hoisted_120 = { class: "mb-6 text-gray-700" }
const _hoisted_121 = { class: "flex flex-wrap gap-3" }

import BackButton from "@/components/common/BackButton.vue";
import { computed, onMounted, reactive, ref, watch } from "vue";
import {
  CheckCircleIcon,
  TrashIcon,
  DocumentDownloadIcon,
} from "@heroicons/vue/solid";
import { XIcon } from "@heroicons/vue/outline";
import DocumentCreate from "@/types/documents/document/DocumentCreate";
import DocumentDataService from "@/services/documents/document/DocumentDataService";
import DocumentTemplateDataService from "@/services/documents/documentTemplate/DocumentTemplateDataService";
import DocumentConstructorDataService from "@/services/documents/DocumentConstructor/DocumentConstructorDataService";
import UserDataService from "@/services/users/UserDataService";
import { onBeforeRouteLeave, useRoute, useRouter } from "vue-router";
import Multiselect from "@vueform/multiselect";
import Editor from "@tinymce/tinymce-vue";
import { required, maxLength } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { StatusesEnum } from "@/store";
import DocumentConstructor from "../../../types/documents/documentConstructor/DocumentConstructor";
import { DocumentActions } from "@/store/modules/document/actions";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { DocumentGetters } from "@/store/modules/document/getters";
import { DocumentMutations } from "@/store/modules/document/mutations";
import { DocumentConstructorActions } from "@/store/modules/documentConstructor/actions";
import { DocumentConstructorGetters } from "@/store/modules/documentConstructor/getters";
import { NomenclatureActions } from "@/store/modules/nomenclature/actions";
import { NomenclatureGetters } from "@/store/modules/nomenclature/getters";
import { default as CustomMultiSelect } from "@/components/common/Multiselect.vue";
import Modal from "@/components/common/Modal.vue";
import { getLocale, t } from "@/i18n";
import { useEsedoDictionaries } from "@/composables/useEsedoDictionaries";
import { defaultEsedoConfig } from "@/types/documents/documentConstructor/EsedoConfig";
import { fullTinyMceConfig, tinyMceScriptSrc } from "@/utils/tinymceConfig";
import ManualField from "@/types/documents/documentTemplate/ManualField";
import DocumentTemplate from "@/types/documents/documentTemplate/DocumentTemplate";
import Nomenclature from "@/types/documents/nomenclature/Nomenclature";
import { filterDocumentTemplatesByNomenclature } from "@/utils/documentTemplateFilter";
import { DocumentFileEditableSource } from "@/types/documents/document/DocumentFiles";
import { formatTemplateFieldValue } from "@/utils/documentBatchFields";
import DocumentUploadZone from "@/components/common/DocumentUploadZone.vue";

type FilledPreviewConflictChoice = "KEEP" | "REBUILD" | null;
interface FileFieldEditChange {
  tag: string;
  label: string;
  before: string;
  after: string;
  beforeValue: unknown;
  afterValue: unknown;
}

interface FileEditChanges {
  fieldChanges: FileFieldEditChange[];
  manualTextChanged: boolean;
}

interface reachedEndEventData {
  isVisible: boolean;
  query: string;
}
enum getFilterUserActionTypes {
  CLICK = 0,
  SEARCH = 1,
  SCROLL = 2,
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const toast = useToast();
const route = useRoute();
const router = useRouter();

const state = reactive<DocumentCreate>({
  id: undefined,
  constructorId: "",
  linkedDocId:
    typeof route.params.linkedDocumentId !== "undefined"
      ? route.params.linkedDocumentId
      : null,
  documentInfo: {
    title: "",
    nomenclature: "",
    regNumber: "",
    description: "",
    price: "",
    esedoDocumentTypeId: null,
    esedoQuestionNatureId: null,
    counterpartyIds: [],
  },
  documentProcessesInfo: {
    isQueue: false,
    deadline: "",
    processList: [],
  },
  documentFiles: [],
});
const rules = {
  id: {},
  constructorId: { required },
  documentInfo: {
    title: { required },
    nomenclature: { required },
    regNumber: {},
    description: {},
    price: {},
  },
  documentProcessesInfo: {
    isQueue: {},
    deadline: { required },
    processList: {},
  },
  documentFiles: {},
};
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });

const showTemplate = ref(false);
const showFilledPreview = ref(false);
const filledPreviewHtml = ref("");
const generatedFilledPreviewHtml = ref("");
const filledPreviewFieldSnapshot = ref("");
const filledPreviewInitialized = ref(false);
const filledPreviewManuallyEdited = ref(false);
const showFilledPreviewConflictModal = ref(false);
let filledPreviewConflictResolve:
  | ((choice: FilledPreviewConflictChoice) => void)
  | null = null;
const currentTemplateId = ref();
const convertedFile = ref(false);
const showLeaveModal = ref(false);
let leaveNavigationResolve: ((allow: boolean) => void) | null = null;
const executionModeOptions = [
  { value: true, label: t("docForm.serialExecution") },
  { value: false, label: t("docForm.parallelExecution") },
];
const processTemplates = ref<any[]>([]);
const getProcessDisplayName = (process: any) => {
  if (process?.templateName) {
    return process.templateName;
  }
  if (process?.templateId) {
    return resolveProcessTemplateName(process.templateId);
  }
  return t("docForm.process");
};
const resolveProcessTemplate = (templateId: string | null | undefined) =>
  processTemplates.value.find((item: any) => item.id === templateId);
const resolveLocalizedTemplateValue = (
  template: any,
  field: "name" | "actionName"
) => {
  if (!template) {
    return "";
  }

  const locale = getLocale();
  const i18nField = `${field}I18n`;
  const localized = template?.[i18nField];

  if (localized?.[locale]) {
    return localized[locale];
  }
  if (localized?.ru) {
    return localized.ru;
  }
  if (localized?.en) {
    return localized.en;
  }

  return template?.[field] ?? "";
};
const resolveProcessTemplateName = (templateId: string | null | undefined) => {
  if (!templateId) {
    return "";
  }
  const template = resolveProcessTemplate(templateId);
  return resolveLocalizedTemplateValue(template, "name");
};
const freeProcessOptions = computed(() => {
  return (constructorInfo.value?.process || [])
    .filter((item: any) => item.processMode === "FREE")
    .map((item: any) => ({
      ...item,
      displayName:
        item.templateName ||
        (item.freeTemplateIds || [])
          .map((templateId: string) => resolveProcessTemplateName(templateId))
          .filter(Boolean)
          .join(", ") ||
        t("docForm.process"),
    }));
});
const defaultFreeProcessConfig = computed(
  () => freeProcessOptions.value[0] ?? null
);
const getAvailableTemplateOptions = (process: any) =>
  (process.availableTemplates || []).map((templateId: string) => ({
    value: templateId,
    label: resolveProcessTemplateName(templateId),
  }));
const templateFile = ref({
  name: "",
  templateName: "",
  templateId: "",
  template: "",
  footerEnabled: false,
  footerScope: "LAST_PAGE" as "ALL_PAGES" | "LAST_PAGE",
  footerHtml: "",
  footerHeightMm: 25,
  manualFields: [] as ManualField[],
  manualFieldValues: {} as Record<string, any>,
  manualFieldErrors: {} as Record<string, string>,
  errorMessage: "",
});
const createSubTemplateFileState = () => ({
  name: "",
  templateName: "",
  templateId: "",
  template: "",
  footerEnabled: false,
  footerScope: "LAST_PAGE" as "ALL_PAGES" | "LAST_PAGE",
  footerHtml: "",
  footerHeightMm: 25,
  manualFields: [] as ManualField[],
  manualFieldValues: {} as Record<string, any>,
  manualFieldErrors: {} as Record<string, string>,
  templateError: "",
  errorMessage: "",
});
const subTemplateFile = ref(createSubTemplateFileState());
const editingMainFileGuid = ref<string | null>(null);
const editingMainSource = ref<DocumentFileEditableSource | null>(null);
const editingSubFileGuid = ref<string | null>(null);
const editingSubSource = ref<DocumentFileEditableSource | null>(null);
const generatedSubPreviewHtml = ref("");
const subPreviewFieldSnapshot = ref("");
const subPreviewManuallyEdited = ref(false);

const fileEditChanges = reactive<Record<string, FileEditChanges>>({});
const selectedFileEditChanges = ref<FileEditChanges | null>(null);

const getFilledPreviewFieldSnapshot = () =>
  JSON.stringify({
    templateId: String(templateFile.value.templateId ?? ""),
    values: templateFile.value.manualFields.map((field) => ({
      tag: field.tag,
      value: Array.isArray(templateFile.value.manualFieldValues[field.tag])
        ? [...templateFile.value.manualFieldValues[field.tag]]
        : templateFile.value.manualFieldValues[field.tag] ?? null,
    })),
  });

const resetFilledPreviewState = () => {
  showFilledPreview.value = false;
  filledPreviewHtml.value = "";
  generatedFilledPreviewHtml.value = "";
  filledPreviewFieldSnapshot.value = "";
  filledPreviewInitialized.value = false;
  filledPreviewManuallyEdited.value = false;
};

const markFilledPreviewAsEdited = () => {
  if (filledPreviewInitialized.value) {
    filledPreviewManuallyEdited.value = true;
  }
};

const hasFilledPreviewManualEdits = () =>
  filledPreviewManuallyEdited.value &&
  filledPreviewHtml.value !== generatedFilledPreviewHtml.value;

const filledPreviewFieldsChanged = () =>
  filledPreviewFieldSnapshot.value !== getFilledPreviewFieldSnapshot();

const restoreFieldValuesFromSnapshot = (
  target: Record<string, any>,
  snapshot: string
) => {
  try {
    const values = JSON.parse(snapshot)?.values;
    if (!Array.isArray(values)) return;
    values.forEach((item: { tag: string; value: any }) => {
      target[item.tag] = Array.isArray(item.value)
        ? [...item.value]
        : item.value ?? "";
    });
  } catch (error) {
    console.error(error);
  }
};

const getSubPreviewFieldSnapshot = () =>
  JSON.stringify({
    templateId: String(subTemplateFile.value.templateId ?? ""),
    values: subTemplateFile.value.manualFields.map((field) => ({
      tag: field.tag,
      value: Array.isArray(subTemplateFile.value.manualFieldValues[field.tag])
        ? [...subTemplateFile.value.manualFieldValues[field.tag]]
        : subTemplateFile.value.manualFieldValues[field.tag] ?? null,
    })),
  });

const resetSubPreviewState = () => {
  generatedSubPreviewHtml.value = "";
  subPreviewFieldSnapshot.value = "";
  subPreviewManuallyEdited.value = false;
};

const markSubPreviewAsEdited = () => {
  if (editingSubFileGuid.value && generatedSubPreviewHtml.value) {
    subPreviewManuallyEdited.value = true;
  }
};

const hasSubPreviewManualEdits = () =>
  subPreviewManuallyEdited.value &&
  subTemplateFile.value.template !== generatedSubPreviewHtml.value;

const subPreviewFieldsChanged = () =>
  subPreviewFieldSnapshot.value !== getSubPreviewFieldSnapshot();

const requestFilledPreviewConflictChoice = () => {
  showFilledPreviewConflictModal.value = true;
  return new Promise<FilledPreviewConflictChoice>((resolve) => {
    filledPreviewConflictResolve = resolve;
  });
};

const resolveFilledPreviewConflict = (choice: FilledPreviewConflictChoice) => {
  showFilledPreviewConflictModal.value = false;
  if (filledPreviewConflictResolve) {
    filledPreviewConflictResolve(choice);
    filledPreviewConflictResolve = null;
  }
};

const isSubTemplate = ref(false);
const showSubTemplate = ref(false);
const currentSubTemplateId = ref("");
const isGeneratingSubTemplate = ref(false);
const constructorInfo = ref<DocumentConstructor>({
  name: "",
  description: "",
  status: StatusesEnum.ACTIVE,
  params: {
    title: {
      isRequired: true,
      isSelected: true,
    },
    nomenclature: {
      isRequired: true,
      isSelected: true,
    },
    mainFile: {
      isRequired: true,
      isSelected: true,
    },
    subFile: {
      isRequired: false,
      isSelected: false,
    },
    description: {
      isRequired: false,
      isSelected: false,
    },
    price: {
      isRequired: false,
      isSelected: false,
    },
    esedoConfig: defaultEsedoConfig(),
  },
  process: [],
});
const {
  documentTypes: esedoDocumentTypes,
  questionNatures: esedoQuestionNatures,
  partners: esedoPartners,
  loadAll: loadEsedoDictionaries,
} = useEsedoDictionaries();

const esedoEnabled = computed(
  () => constructorInfo.value.params?.esedoConfig?.enabled === true
);
const counterpartyMode = computed(
  () =>
    constructorInfo.value.params?.esedoConfig?.counterpartySelectionMode ??
    "NOT_USED"
);
const showCounterparties = computed(
  () => esedoEnabled.value && counterpartyMode.value !== "NOT_USED"
);
const counterpartyRequired = computed(
  () => counterpartyMode.value === "REQUIRED"
);
const counterpartyError = ref("");
const constructors = ref();
const nomenclatures = ref<Nomenclature[]>([]);
const users = ref<any[]>([]);
const userNameCache = ref<Record<string, string>>({});
let mainFiles = ref([]);
let attachedFiles = ref([]);
let currentDate = new Date().toISOString().slice(0, 10);
const templates = ref<DocumentTemplate[] | null>(null);
const selectedNomenclature = computed<Nomenclature | null>(() => {
  const selectedId = String(state.documentInfo.nomenclature || "");
  if (!selectedId) {
    return null;
  }
  return (
    nomenclatures.value.find(
      (nomenclature) => String(nomenclature.id) === selectedId
    ) ?? null
  );
});
const availableDocumentTemplates = computed<DocumentTemplate[]>(() =>
  filterDocumentTemplatesByNomenclature(
    templates.value ?? [],
    selectedNomenclature.value
  )
);
const getUserFullNameById = (userId: string) =>
  users.value.find((item: any) => item.id === userId)?.fullName ??
  userNameCache.value[userId] ??
  String(userId);
const buildUsersInfoByIds = (userIds: string[] = []) =>
  userIds.map((id) => ({ id, fullName: getUserFullNameById(id) }));
const hydrateLockedProcessUsers = async () => {
  const ids = Array.from(
    new Set(
      state.documentProcessesInfo.processList
        .flatMap((process: any) => process.lockedExecutorUserIds || [])
        .filter((id: any) => id !== null && id !== undefined && String(id).trim())
        .map((id: any) => String(id))
    )
  );

  const missingIds = ids.filter(
    (id) =>
      !users.value.some((item: any) => item.id === id) &&
      !userNameCache.value[id]
  );

  await Promise.all(
    missingIds.map(async (id) => {
      try {
        const response = await UserDataService.get(id);
        const user = response.data?.data;
        userNameCache.value[id] =
          user?.fullName ||
          [user?.surname, user?.name, user?.middleName]
            .filter(Boolean)
            .join(" ") ||
          String(id);
      } catch (error) {
        userNameCache.value[id] = String(id);
      }
    })
  );

  state.documentProcessesInfo.processList.forEach((process: any) => {
    if (!isUserSelectionLocked(process)) {
      return;
    }
    process.usersInfo = buildUsersInfoByIds(process.lockedExecutorUserIds);
    process.usersFilterInit = process.usersInfo;
  });
};
const isUserSelectionLocked = (process: any) =>
  !process.isFreeInstance &&
  Array.isArray(process.lockedExecutorUserIds) &&
  process.lockedExecutorUserIds.length > 0;
const getLockedUsersLabel = (process: any) =>
  (process.usersInfo || [])
    .map((user: any) => user.fullName)
    .filter(Boolean)
    .join(", ");
const syncProcessTemplateMeta = (process: any) => {
  const template = resolveProcessTemplate(process.templateId);
  process.templateName =
    resolveLocalizedTemplateValue(template, "name") ||
    process.templateName ||
    null;
  process.isSigning = template?.isSigning ?? false;
  if (!process.name || process.isFreeInstance) {
    process.name = process.templateName || t("docForm.process");
  }
};

const resetManualFieldState = (manualFields: ManualField[] = []) => {
  templateFile.value.manualFields = manualFields
    .slice()
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  templateFile.value.manualFieldValues = {};
  templateFile.value.manualFieldErrors = {};
  templateFile.value.manualFields.forEach((field) => {
    templateFile.value.manualFieldValues[field.tag] =
      field.type === "MULTI_SELECT" ? [] : "";
  });
};

const loadSelectedTemplateConfig = async () => {
  if (!templateFile.value.templateId) {
    resetManualFieldState();
    templateFile.value.template = "";
    resetFilledPreviewState();
    return;
  }
  const response = await DocumentTemplateDataService.get(
    templateFile.value.templateId
  );
  const template = response.data.data;
  templateFile.value.template = template.template;
  templateFile.value.templateName = template.name;
  templateFile.value.footerEnabled = template.footerEnabled ?? false;
  templateFile.value.footerScope = template.footerScope ?? "LAST_PAGE";
  templateFile.value.footerHtml = template.footerHtml ?? "";
  templateFile.value.footerHeightMm = template.footerHeightMm ?? 25;
  editingMainFileGuid.value = null;
  editingMainSource.value = null;
  currentTemplateId.value = templateFile.value.templateId;
  resetFilledPreviewState();
  resetManualFieldState(template.manualFields ?? []);
};

const validateManualFields = () => {
  templateFile.value.manualFieldErrors = {};
  templateFile.value.manualFields.forEach((field) => {
    const value = templateFile.value.manualFieldValues[field.tag];
    const isEmpty = Array.isArray(value) ? value.length === 0 : !value;
    if (field.required && isEmpty) {
      templateFile.value.manualFieldErrors[field.tag] = t(
        "docForm.fieldRequired"
      );
    }
  });
  return Object.keys(templateFile.value.manualFieldErrors).length === 0;
};

const resetSubManualFieldState = (manualFields: ManualField[] = []) => {
  subTemplateFile.value.manualFields = manualFields
    .slice()
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  subTemplateFile.value.manualFieldValues = {};
  subTemplateFile.value.manualFieldErrors = {};
  subTemplateFile.value.manualFields.forEach((field) => {
    subTemplateFile.value.manualFieldValues[field.tag] =
      field.type === "MULTI_SELECT" ? [] : "";
  });
};

const loadSelectedSubTemplateConfig = async () => {
  subTemplateFile.value.templateError = "";
  showSubTemplate.value = false;
  resetSubPreviewState();
  if (!subTemplateFile.value.templateId) {
    subTemplateFile.value.template = "";
    currentSubTemplateId.value = "";
    resetSubManualFieldState();
    return;
  }

  const response = await DocumentTemplateDataService.get(
    subTemplateFile.value.templateId
  );
  const template = response.data.data;
  subTemplateFile.value.template = template.template;
  subTemplateFile.value.templateName = template.name;
  subTemplateFile.value.footerEnabled = template.footerEnabled ?? false;
  subTemplateFile.value.footerScope = template.footerScope ?? "LAST_PAGE";
  subTemplateFile.value.footerHtml = template.footerHtml ?? "";
  subTemplateFile.value.footerHeightMm = template.footerHeightMm ?? 25;
  editingSubFileGuid.value = null;
  editingSubSource.value = null;
  currentSubTemplateId.value = subTemplateFile.value.templateId;
  resetSubManualFieldState(template.manualFields ?? []);
};

const validateSubManualFields = () => {
  subTemplateFile.value.manualFieldErrors = {};
  subTemplateFile.value.manualFields.forEach((field) => {
    const value = subTemplateFile.value.manualFieldValues[field.tag];
    const isEmpty = Array.isArray(value) ? value.length === 0 : !value;
    if (field.required && isEmpty) {
      subTemplateFile.value.manualFieldErrors[field.tag] = t(
        "docForm.fieldRequired"
      );
    }
  });
  return Object.keys(subTemplateFile.value.manualFieldErrors).length === 0;
};

const isTemplateAvailable = (templateId: string) =>
  availableDocumentTemplates.value.some(
    (template) => String(template.id) === String(templateId)
  );

const resetUnavailableTemplateSelections = () => {
  if (templates.value === null) {
    return;
  }

  if (
    templateFile.value.templateId &&
    !isTemplateAvailable(templateFile.value.templateId)
  ) {
    templateFile.value.templateId = "";
    templateFile.value.template = "";
    templateFile.value.errorMessage = "";
    currentTemplateId.value = undefined;
    showTemplate.value = false;
    resetFilledPreviewState();
    resetManualFieldState();
  }

  if (
    subTemplateFile.value.templateId &&
    !isTemplateAvailable(subTemplateFile.value.templateId)
  ) {
    subTemplateFile.value.templateId = "";
    subTemplateFile.value.template = "";
    subTemplateFile.value.templateError = "";
    currentSubTemplateId.value = "";
    showSubTemplate.value = false;
    resetSubManualFieldState();
  }
};

watch(availableDocumentTemplates, resetUnavailableTemplateSelections);

const buildSubFieldConfig = () =>
  subTemplateFile.value.manualFields.map((field) => {
    const value = subTemplateFile.value.manualFieldValues[field.tag];
    return {
      key: field.tag,
      name: field.name,
      type: field.type,
      required: field.required,
      delimiter: field.delimiter,
      outputFormat: field.outputFormat,
      options: field.options ?? [],
      value: Array.isArray(value) ? value.join(field.delimiter || ", ") : value,
      values: Array.isArray(value) ? value : undefined,
    };
  });

const buildSubFilledTemplateHtml = (
  templateHtml = subTemplateFile.value.template
) => {
  let html = templateHtml || "";
  subTemplateFile.value.manualFields.forEach((field) => {
    const raw = subTemplateFile.value.manualFieldValues[field.tag];
    const value = Array.isArray(raw)
      ? raw.join(field.delimiter || ", ")
      : raw == null
      ? ""
      : formatTemplateFieldValue(String(raw), field.type, field.outputFormat);
    html = html.split(field.tag).join(value);
    if (!field.tag.startsWith("key_")) {
      html = html.split(`key_${field.tag}`).join(value);
    }
  });
  return html;
};

const buildFieldConfig = () => {
  return templateFile.value.manualFields.map((field) => {
    const value = templateFile.value.manualFieldValues[field.tag];
    return {
      key: field.tag,
      name: field.name,
      type: field.type,
      required: field.required,
      delimiter: field.delimiter,
      outputFormat: field.outputFormat,
      options: field.options ?? [],
      value: Array.isArray(value) ? value.join(field.delimiter || ", ") : value,
      values: Array.isArray(value) ? value : undefined,
    };
  });
};

const cloneEditableValues = (values: Record<string, any>) =>
  JSON.parse(JSON.stringify(values ?? {}));

const templateDisplayName = (templateId: string, fallback: string) =>
  availableDocumentTemplates.value.find(
    (item) => String(item.id) === String(templateId)
  )?.name || fallback;

const editableSourceFor = (guid: string) =>
  state.documentFiles.find((item) => item.fileGuid === guid)?.editableSource ??
  null;

const fileEditChangesFor = (guid: string) => fileEditChanges[guid] ?? null;

const openFileEditChanges = (guid: string) => {
  selectedFileEditChanges.value = fileEditChangesFor(guid);
};

const closeFileEditChanges = () => {
  selectedFileEditChanges.value = null;
};

const cloneChangeValue = (value: unknown) =>
  value === undefined ? null : JSON.parse(JSON.stringify(value));

const sameChangeValue = (left: unknown, right: unknown) =>
  JSON.stringify(left ?? null) === JSON.stringify(right ?? null);

const displayChangeValue = (value: unknown, field: ManualField) => {
  if (value === null || value === undefined || value === "") {
    return t("docForm.emptyValue");
  }
  const values = Array.isArray(value) ? value : [value];
  return values
    .map((item) => {
      const option = (field.options ?? []).find(
        (candidate) => String(candidate.value) === String(item)
      );
      if (option) return option.label;
      return formatTemplateFieldValue(
        String(item),
        field.type,
        field.outputFormat
      );
    })
    .join(field.delimiter || ", ");
};

const buildFieldEditChanges = (
  before: DocumentFileEditableSource,
  after: DocumentFileEditableSource
): FileFieldEditChange[] => {
  const fields = new Map<string, ManualField>();
  [...(before.manualFields ?? []), ...(after.manualFields ?? [])].forEach(
    (field) => fields.set(field.tag, field)
  );
  return Array.from(fields.values()).reduce<FileFieldEditChange[]>(
    (changes, field) => {
      const beforeValue = cloneChangeValue(before.fieldValues?.[field.tag]);
      const afterValue = cloneChangeValue(after.fieldValues?.[field.tag]);
      if (!sameChangeValue(beforeValue, afterValue)) {
        changes.push({
          tag: field.tag,
          label: field.name || field.tag,
          before: displayChangeValue(beforeValue, field),
          after: displayChangeValue(afterValue, field),
          beforeValue,
          afterValue,
        });
      }
      return changes;
    },
    []
  );
};

const rememberFileEditChanges = (
  oldGuid: string,
  newGuid: string,
  before: DocumentFileEditableSource,
  after: DocumentFileEditableSource,
  manualTextChanged: boolean
) => {
  const previous = fileEditChanges[oldGuid];
  const merged = new Map<string, FileFieldEditChange>(
    (previous?.fieldChanges ?? []).map((change) => [change.tag, change])
  );

  buildFieldEditChanges(before, after).forEach((change) => {
    const previousChange = merged.get(change.tag);
    if (
      previousChange &&
      sameChangeValue(previousChange.beforeValue, change.afterValue)
    ) {
      merged.delete(change.tag);
      return;
    }
    merged.set(
      change.tag,
      previousChange
        ? {
            ...change,
            before: previousChange.before,
            beforeValue: previousChange.beforeValue,
          }
        : change
    );
  });

  delete fileEditChanges[oldGuid];
  const summary: FileEditChanges = {
    fieldChanges: Array.from(merged.values()),
    manualTextChanged:
      Boolean(previous?.manualTextChanged) || manualTextChanged,
  };
  if (summary.fieldChanges.length || summary.manualTextChanged) {
    fileEditChanges[newGuid] = summary;
  }
};

const replaceGeneratedFile = (
  oldGuid: string | null,
  fileGuid: string,
  type: "MAIN" | "SUB",
  editableSource: DocumentFileEditableSource
) => {
  const nextFile = { fileGuid, type, errorMessage: "", editableSource };
  if (!oldGuid) {
    state.documentFiles.push(nextFile);
    return;
  }
  const index = state.documentFiles.findIndex(
    (item) => item.fileGuid === oldGuid
  );
  if (index >= 0) state.documentFiles.splice(index, 1, nextFile);
  else state.documentFiles.push(nextFile);
};

async function handleSubmit(isFormValid: boolean) {
  if (isSubmitting.value) {
    return;
  }
  submitted.value = true;
  counterpartyError.value = "";

  if (!esedoEnabled.value) {
    state.documentInfo.esedoDocumentTypeId = null;
    state.documentInfo.esedoQuestionNatureId = null;
    state.documentInfo.counterpartyIds = [];
  } else if (counterpartyMode.value === "NOT_USED") {
    state.documentInfo.counterpartyIds = [];
  } else if (
    counterpartyRequired.value &&
    !state.documentInfo.counterpartyIds?.length
  ) {
    counterpartyError.value = t("esedo.partnersRequired");
    return;
  }

  if (!isFormValid) {
    return;
  }

  state.documentProcessesInfo.processList =
    state.documentProcessesInfo.processList.map((item, index) => ({
      ...item,
      position: index + 1,
      users: [...item.users],
    }));

  isSubmitting.value = true;
  try {
    route.name === "DocumentEdit"
      ? await updateDocument()
      : await createDocument();
  } finally {
    isSubmitting.value = false;
  }
}

const uploadTemplate = async () => {
  if (!templateFile.value.templateId) {
    templateFile.value.errorMessage = t("docForm.templateRequired");
    return;
  }
  if (!templateFile.value.name) {
    templateFile.value.errorMessage = t("docForm.fileNameRequired");
    return;
  }
  if (!validateManualFields()) {
    return;
  }

  if (templateFile.value?.template === "") {
    await loadSelectedTemplateConfig();
  }
  let templateContent = templateFile.value.template;
  let fieldConfig = buildFieldConfig();

  if (filledPreviewInitialized.value && filledPreviewFieldsChanged()) {
    if (hasFilledPreviewManualEdits()) {
      const choice = await requestFilledPreviewConflictChoice();
      if (choice === null) {
        return;
      }
      if (choice === "REBUILD") {
        rebuildFilledPreviewFromFields();
      } else {
        restoreFieldValuesFromSnapshot(
          templateFile.value.manualFieldValues,
          filledPreviewFieldSnapshot.value
        );
      }
    } else {
      rebuildFilledPreviewFromFields();
      }
    }

  if (
    filledPreviewInitialized.value &&
    (showFilledPreview.value || hasFilledPreviewManualEdits())
  ) {
    templateContent = filledPreviewHtml.value;
    fieldConfig = [];
  }

  const originalEditingSource = editingMainSource.value;
  const manualTextChanged = Boolean(
    editingMainFileGuid.value && hasFilledPreviewManualEdits()
  );

  const template =
    "<div style=\"font-family: 'times new roman', times, serif;\">" +
    templateContent +
    "</div>";
  try {
    const editorHtml =
      fieldConfig.length === 0 ? templateContent : buildFilledTemplateHtml();
    const editableSource: DocumentFileEditableSource = {
      templateId: String(templateFile.value.templateId),
      templateName: templateDisplayName(
        templateFile.value.templateId,
        templateFile.value.templateName
      ),
      fileName: templateFile.value.name,
      templateHtml: templateFile.value.template,
      editorHtml,
      footerEnabled: templateFile.value.footerEnabled,
      footerScope: templateFile.value.footerScope,
      footerHtml: templateFile.value.footerHtml,
      footerHeightMm: templateFile.value.footerHeightMm,
      manualFields: templateFile.value.manualFields,
      fieldValues: cloneEditableValues(templateFile.value.manualFieldValues),
    };
    await DocumentTemplateDataService.convert({
      name: templateFile.value.name,
      templateId: templateFile.value.templateId,
      template,
      footerEnabled: templateFile.value.footerEnabled,
      footerScope: templateFile.value.footerScope,
      footerHtml: templateFile.value.footerHtml,
      footerHeightMm: templateFile.value.footerHeightMm,
      fieldConfig,
    }).then((response) => {
      const oldGuid = editingMainFileGuid.value;
      replaceGeneratedFile(
        oldGuid,
        response.data.data.fileGuid,
        "MAIN",
        editableSource
      );
      if (oldGuid && originalEditingSource) {
        rememberFileEditChanges(
          oldGuid,
          response.data.data.fileGuid,
          originalEditingSource,
          editableSource,
          manualTextChanged
        );
      }
      const mainIndex = mainFiles.value.findIndex(
        (file: any) => file.guid === oldGuid
      );
      const fileInfo = {
        guid: response.data.data.fileGuid,
        name: templateFile.value.name,
      };
      if (mainIndex >= 0) mainFiles.value.splice(mainIndex, 1, fileInfo);
      else mainFiles.value.push(fileInfo);
      editingMainFileGuid.value = null;
      editingMainSource.value = null;
      convertedFile.value = true;
    });
  } catch (error) {
    console.error(error);
  }
};

const getTemplate = async () => {
  if (
    showTemplate.value &&
    currentTemplateId.value &&
    templateFile.value.templateId == currentTemplateId.value
  ) {
    showTemplate.value = false;
  } else {
    if (
      !templateFile.value.template ||
      currentTemplateId.value != templateFile.value.templateId
    ) {
      templateFile.value.template = (
        await DocumentTemplateDataService.get(templateFile.value.templateId)
      ).data.data.template;
      currentTemplateId.value = templateFile.value.templateId;
      await loadSelectedTemplateConfig();
      showTemplate.value = true;
    } else {
      showTemplate.value = true;
    }
  }
};

const resolveManualFieldPreviewValue = (field: ManualField) => {
  const raw = templateFile.value.manualFieldValues[field.tag];
  if (Array.isArray(raw)) {
    return raw
      .filter((item) => item != null && String(item).trim() !== "")
      .join(field.delimiter || ", ");
  }
  return raw == null
    ? ""
    : formatTemplateFieldValue(String(raw), field.type, field.outputFormat);
};

const buildFilledTemplateHtml = () => {
  let html = templateFile.value.template || "";
  templateFile.value.manualFields.forEach((field) => {
    const value = resolveManualFieldPreviewValue(field);
    const key = field.tag;
    html = html.split(key).join(value);
    if (!key.startsWith("key_")) {
      html = html.split(`key_${key}`).join(value);
    }
  });
  return html;
};

const rebuildFilledPreviewFromFields = () => {
  const html = buildFilledTemplateHtml();
  filledPreviewHtml.value = html;
  generatedFilledPreviewHtml.value = html;
  filledPreviewFieldSnapshot.value = getFilledPreviewFieldSnapshot();
  filledPreviewInitialized.value = true;
  filledPreviewManuallyEdited.value = false;
};

const openFilledTemplatePreview = async () => {
  if (!templateFile.value.templateId) {
    templateFile.value.errorMessage = t("docForm.templateRequired");
    return;
  }
  if (!templateFile.value.name) {
    templateFile.value.errorMessage = t("docForm.fileNameRequired");
    return;
  }
  if (!validateManualFields()) {
    return;
  }
  if (!templateFile.value.template) {
    await loadSelectedTemplateConfig();
  }

  if (!filledPreviewInitialized.value || !hasFilledPreviewManualEdits()) {
    rebuildFilledPreviewFromFields();
  } else if (filledPreviewFieldsChanged()) {
    const choice = await requestFilledPreviewConflictChoice();
    if (choice === null) {
      return;
    }
    if (choice === "REBUILD") {
      rebuildFilledPreviewFromFields();
    } else {
      restoreFieldValuesFromSnapshot(
        templateFile.value.manualFieldValues,
        filledPreviewFieldSnapshot.value
      );
    }
  }
  showFilledPreview.value = true;
};

const backToTemplateFields = () => {
  showFilledPreview.value = false;
};

const editGeneratedMainFile = async (guid: string) => {
  const source = editableSourceFor(guid);
  if (!source) return;
  await ensureDocumentTemplatesLoaded();
  isTemplate.value = true;
  convertedFile.value = false;
  editingMainFileGuid.value = guid;
  editingMainSource.value = JSON.parse(JSON.stringify(source));
  templateFile.value = {
    name: source.fileName,
    templateName: source.templateName,
    templateId: source.templateId ?? "",
    template: source.templateHtml,
    footerEnabled: source.footerEnabled ?? false,
    footerScope: source.footerScope ?? "LAST_PAGE",
    footerHtml: source.footerHtml ?? "",
    footerHeightMm: source.footerHeightMm ?? 25,
    manualFields: JSON.parse(JSON.stringify(source.manualFields ?? [])),
    manualFieldValues: cloneEditableValues(source.fieldValues),
    manualFieldErrors: {},
    errorMessage: "",
  };
  currentTemplateId.value = source.templateId;
  filledPreviewHtml.value = source.editorHtml;
  generatedFilledPreviewHtml.value = source.editorHtml;
  filledPreviewFieldSnapshot.value = getFilledPreviewFieldSnapshot();
  filledPreviewInitialized.value = true;
  filledPreviewManuallyEdited.value = false;
  showFilledPreview.value = true;
};

const hasUnsavedCreateProgress = () => {
  if (route.name === "DocumentEdit" || isSubmitting.value) {
    return false;
  }
  if (state.constructorId) {
    return true;
  }
  if (mainFiles.value.length > 0 || state.documentFiles.length > 0) {
    return true;
  }
  if (templateFile.value.templateId || templateFile.value.name) {
    return true;
  }
  return false;
};

const stayOnCreatePage = () => {
  showLeaveModal.value = false;
  if (leaveNavigationResolve) {
    leaveNavigationResolve(false);
    leaveNavigationResolve = null;
  }
};

const confirmLeaveCreatePage = () => {
  showLeaveModal.value = false;
  if (leaveNavigationResolve) {
    leaveNavigationResolve(true);
    leaveNavigationResolve = null;
  }
};

onBeforeRouteLeave(() => {
  if (!hasUnsavedCreateProgress()) {
    return true;
  }
  showLeaveModal.value = true;
  return new Promise<boolean>((resolve) => {
    leaveNavigationResolve = resolve;
  });
});

const changeMainFile = async () => {
  await setDocumentSourceMode(!isTemplate.value);
};

const setDocumentSourceMode = async (generateMode: boolean) => {
  isTemplate.value = generateMode;
  resetFilledPreviewState();
  if (generateMode) {
    await ensureDocumentTemplatesLoaded();
  }
};

const ensureDocumentTemplatesLoaded = async () => {
  if (!templates.value) {
    templates.value = await loadAllDocumentTemplates();
  }
};

const loadAllDocumentTemplates = async () => {
  const result: DocumentTemplate[] = [];
  let page = 1;
  let totalPages = 1;

  do {
    const response = await DocumentTemplateDataService.getAll({ page });
    const data = response.data.data;
    result.push(...(data.items ?? []));
    totalPages = Number(data.pager?.totalPages ?? totalPages);
    page += 1;
  } while (page <= totalPages);

  return result;
};

const changeSubFileMode = async () => {
  await setSubDocumentSourceMode(!isSubTemplate.value);
};

const setSubDocumentSourceMode = async (generateMode: boolean) => {
  isSubTemplate.value = generateMode;
  showSubTemplate.value = false;
  if (generateMode) {
    await ensureDocumentTemplatesLoaded();
  }
};

const toggleSubTemplatePreview = async () => {
  if (!subTemplateFile.value.templateId) {
    return;
  }
  if (
    !subTemplateFile.value.template ||
    currentSubTemplateId.value !== subTemplateFile.value.templateId
  ) {
    await loadSelectedSubTemplateConfig();
  }
  showSubTemplate.value = !showSubTemplate.value;
};

const syncEditedSubPreviewFromFields = async () => {
  if (!editingSubFileGuid.value || !subPreviewFieldsChanged()) {
    return true;
  }

  if (hasSubPreviewManualEdits()) {
    const choice = await requestFilledPreviewConflictChoice();
    if (choice === null) {
      return false;
    }
    if (choice !== "REBUILD") {
      restoreFieldValuesFromSnapshot(
        subTemplateFile.value.manualFieldValues,
        subPreviewFieldSnapshot.value
      );
      return true;
    }
  }

  const editorHtml = buildSubFilledTemplateHtml(
    editingSubSource.value?.templateHtml ?? ""
  );
  subTemplateFile.value.template = editorHtml;
  generatedSubPreviewHtml.value = editorHtml;
  subPreviewFieldSnapshot.value = getSubPreviewFieldSnapshot();
  subPreviewManuallyEdited.value = false;
  return true;
};

const refreshEditedSubPreview = async () => {
  if (!validateSubManualFields()) return;
  if (await syncEditedSubPreviewFromFields()) {
    showSubTemplate.value = true;
  }
};

const uploadSubTemplate = async () => {
  subTemplateFile.value.templateError = "";
  subTemplateFile.value.errorMessage = "";
  if (!subTemplateFile.value.templateId) {
    subTemplateFile.value.templateError = t("docForm.templateRequired");
    return;
  }
  if (!subTemplateFile.value.name.trim()) {
    subTemplateFile.value.errorMessage = t("docForm.fileNameRequired");
    return;
  }
  if (!validateSubManualFields()) {
    return;
  }
  if (!subTemplateFile.value.template) {
    await loadSelectedSubTemplateConfig();
  }
  if (!(await syncEditedSubPreviewFromFields())) {
    return;
  }

  isGeneratingSubTemplate.value = true;
  try {
    const fieldConfig = editingSubFileGuid.value ? [] : buildSubFieldConfig();
    const editorHtml = editingSubFileGuid.value
      ? subTemplateFile.value.template
      : buildSubFilledTemplateHtml();
    const template =
      "<div style=\"font-family: 'times new roman', times, serif;\">" +
      subTemplateFile.value.template +
      "</div>";
    const response = await DocumentTemplateDataService.convert({
      name: subTemplateFile.value.name.trim(),
      templateId: subTemplateFile.value.templateId,
      template,
      footerEnabled: subTemplateFile.value.footerEnabled,
      footerScope: subTemplateFile.value.footerScope,
      footerHtml: subTemplateFile.value.footerHtml,
      footerHeightMm: subTemplateFile.value.footerHeightMm,
      fieldConfig,
    });
    const fileGuid = response.data.data.fileGuid;
    const oldGuid = editingSubFileGuid.value;
    const originalSource = editingSubSource.value;
    const manualTextChanged = Boolean(oldGuid && hasSubPreviewManualEdits());
    const editableSource: DocumentFileEditableSource = {
      templateId: String(subTemplateFile.value.templateId),
      templateName: templateDisplayName(
        subTemplateFile.value.templateId,
        subTemplateFile.value.templateName
      ),
      fileName: subTemplateFile.value.name.trim(),
      templateHtml:
        originalSource?.templateHtml ?? subTemplateFile.value.template,
      editorHtml,
      footerEnabled: subTemplateFile.value.footerEnabled,
      footerScope: subTemplateFile.value.footerScope,
      footerHtml: subTemplateFile.value.footerHtml,
      footerHeightMm: subTemplateFile.value.footerHeightMm,
      manualFields: JSON.parse(
        JSON.stringify(subTemplateFile.value.manualFields ?? [])
      ),
      fieldValues: cloneEditableValues(subTemplateFile.value.manualFieldValues),
    };
    replaceGeneratedFile(oldGuid, fileGuid, "SUB", editableSource);
    if (oldGuid && originalSource) {
      rememberFileEditChanges(
        oldGuid,
        fileGuid,
        originalSource,
        editableSource,
        manualTextChanged
      );
    }
    const attachedIndex = attachedFiles.value.findIndex(
      (item: any) => item.guid === oldGuid
    );
    const fileInfo = {
      guid: fileGuid,
      name: subTemplateFile.value.name.trim(),
    };
    if (attachedIndex >= 0) {
      attachedFiles.value.splice(attachedIndex, 1, fileInfo);
    } else {
      attachedFiles.value.push(fileInfo);
    }
    subTemplateFile.value = createSubTemplateFileState();
    editingSubFileGuid.value = null;
    editingSubSource.value = null;
    currentSubTemplateId.value = "";
    showSubTemplate.value = false;
    resetSubPreviewState();
  } catch (error) {
    console.error(error);
  } finally {
    isGeneratingSubTemplate.value = false;
  }
};

const editGeneratedSubFile = async (guid: string) => {
  const source = editableSourceFor(guid);
  if (!source) return;
  await ensureDocumentTemplatesLoaded();
  isSubTemplate.value = true;
  editingSubFileGuid.value = guid;
  editingSubSource.value = JSON.parse(JSON.stringify(source));
  subTemplateFile.value = {
    name: source.fileName,
    templateName: source.templateName,
    templateId: source.templateId ?? "",
    template: source.editorHtml,
    footerEnabled: source.footerEnabled ?? false,
    footerScope: source.footerScope ?? "LAST_PAGE",
    footerHtml: source.footerHtml ?? "",
    footerHeightMm: source.footerHeightMm ?? 25,
    manualFields: JSON.parse(JSON.stringify(source.manualFields ?? [])).sort(
      (a: ManualField, b: ManualField) =>
        (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
    ),
    manualFieldValues: cloneEditableValues(source.fieldValues),
    manualFieldErrors: {},
    templateError: "",
    errorMessage: "",
  };
  currentSubTemplateId.value = source.templateId ?? "";
  generatedSubPreviewHtml.value = source.editorHtml;
  subPreviewFieldSnapshot.value = getSubPreviewFieldSnapshot();
  subPreviewManuallyEdited.value = false;
  showSubTemplate.value = true;
};

const uploadFile = async (type: string, files: File[]) => {
  subFileError.value = "";
  for (const selectedFile of files) {
    let formData = new FormData();
    formData.append("file", selectedFile);
    try {
      await DocumentDataService.uploadDocument(formData).then((response) => {
        state.documentFiles.push({
          fileGuid: response.data.data.fileGuid,
          type: type,
          errorMessage: "",
        });
        attachedFiles.value.push({
          guid: response.data.data.fileGuid,
          name: selectedFile.name,
        });
      });
    } catch (error) {
      console.error(error);
      subFileError.value =
        (error as any)?.response?.data?.message ||
        t("documentUpload.uploadFailed");
    }
  }
};

const generateAndDownloadFile = (blob: Blob, fileName: string) => {
  const link = document.createElement("a");
  // create a blobURI pointing to our Blob
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  // some browser needs the anchor to be in the doc
  document.body.append(link);
  link.click();
  link.remove();
  // in case the Blob uses a lot of memory
  setTimeout(() => URL.revokeObjectURL(link.href), 7000);
};

const downloadFile = async (guid: string, fileName: string) => {
  await store.dispatch(DocumentActions.DOWNLOAD, guid);
  const fileBlob = store.getters[DocumentGetters.GET_FILE];

  generateAndDownloadFile(fileBlob, fileName);
};

const deleteMainFile = (indexFile: number, guid: any) => {
  delete fileEditChanges[guid];
  state.documentFiles.forEach((item: any, index: any) => {
    if (item.fileGuid === guid) {
      state.documentFiles.splice(index, 1);
    }
  });
  mainFiles.value.splice(indexFile, 1);
  if (convertedFile.value) {
    convertedFile.value = false;
  }
};

const deleteSubFile = (indexFile: number, guid: any) => {
  delete fileEditChanges[guid];
  state.documentFiles.forEach((item: any, index: any) => {
    if (item.fileGuid === guid) {
      state.documentFiles.splice(index, 1);
    }
  });
  attachedFiles.value.splice(indexFile, 1);
};

const uploadMainFile = async (type: string, files: File[]) => {
  const selectedFile = files[0];
  if (!selectedFile) return;
  mainFileError.value = "";
  let form = new FormData();
  form.append("file", selectedFile);
  try {
    await DocumentDataService.uploadDocument(form).then((response) => {
      state.documentFiles.push({
        fileGuid: response.data.data.fileGuid,
        type: type,
      });
      mainFiles.value.push({
        guid: response.data.data.fileGuid,
        name: selectedFile.name,
      });
    });
  } catch (error) {
    console.error(error);
    mainFileError.value =
      (error as any)?.response?.data?.message ||
      t("documentUpload.uploadFailed");
  }
};

const getInfoAndSetProcessList = async () => {
  state.documentProcessesInfo.processList = [];
  counterpartyError.value = "";
  try {
    await DocumentDataService.getConstructorInfo(state.constructorId).then(
      async (response) => {
        constructorInfo.value = response.data.data;
        if (!constructorInfo.value.params.esedoConfig) {
          constructorInfo.value.params.esedoConfig = defaultEsedoConfig();
        }

        const cfg = constructorInfo.value.params.esedoConfig;
        if (cfg.enabled) {
          loadEsedoDictionaries();
          if (
            state.documentInfo.esedoDocumentTypeId == null &&
            cfg.documentTypeId
          ) {
            state.documentInfo.esedoDocumentTypeId = cfg.documentTypeId;
          }
          if (
            state.documentInfo.esedoQuestionNatureId == null &&
            cfg.questionNatureId
          ) {
            state.documentInfo.esedoQuestionNatureId = cfg.questionNatureId;
          }
          if (cfg.counterpartySelectionMode === "NOT_USED") {
            state.documentInfo.counterpartyIds = [];
          }
        } else {
          state.documentInfo.esedoDocumentTypeId = null;
          state.documentInfo.esedoQuestionNatureId = null;
          state.documentInfo.counterpartyIds = [];
        }

        const mandatoryProcesses = (constructorInfo.value.process || []).filter(
          (item: any) => item.processMode !== "FREE"
        );

        if (route.name == "DocumentEdit" && update.value?.processList) {
          state.documentProcessesInfo.processList = [];
          const existingProcesses = [...update.value.processList].sort(
            (a: any, b: any) => (a.position ?? 0) - (b.position ?? 0)
          );

          existingProcesses.forEach((process: any) => {
            const processConfig = (constructorInfo.value.process || []).find(
              (item: any) => item.processGuid === process.constructorProcessGuid
            );

            if (!processConfig) {
              return;
            }

            state.documentProcessesInfo.processList.push(
              createProcessListItem(
                processConfig,
                processConfig.processMode === "FREE",
                process
              )
            );
          });

          mandatoryProcesses.forEach((mandatoryProcess: any) => {
            const exists = state.documentProcessesInfo.processList.some(
              (item: any) =>
                item.constructorProcessGuid === mandatoryProcess.processGuid &&
                !item.isFreeInstance
            );

            if (!exists) {
              state.documentProcessesInfo.processList.push(
                createProcessListItem(mandatoryProcess, false)
              );
            }
          });
        } else {
          state.documentProcessesInfo.processList = mandatoryProcesses.map(
            (item: any) => createProcessListItem(item, false)
          );
        }

        for (
          let index = 0;
          index < state.documentProcessesInfo.processList.length;
          index++
        ) {
          await getFilterUser(
            state.documentProcessesInfo.processList[index]
              .constructorProcessGuid,
            index,
            getFilterUserActionTypes.CLICK
          );
        }
        await hydrateLockedProcessUsers();
      }
    );
  } catch (error) {
    console.error(error);
  }
};

const createProcessListItem = (
  item: any,
  isFreeInstance = false,
  existingProcess: any = null
) => {
  const lockedExecutorUserIds = item.executorUserIds || [];
  const selectedTemplateId =
    existingProcess?.templateId ??
    (isFreeInstance ? null : item.templateId ?? null);
  const processItem = {
    constructorProcessGuid: item.processGuid,
    sourceProcessGuid: item.processGuid,
    instanceGuid: isFreeInstance ? createGuid() : item.processGuid,
    isFreeInstance,
    position: existingProcess?.position ?? null,
    templateId: selectedTemplateId,
    availableTemplates: item.freeTemplateIds || [],
    isQueue:
      existingProcess?.isQueue ??
      (isFreeInstance ? false : !(item.allowParallel ?? false)),
    comment: "",
    users: existingProcess?.usersInfo ? [] : [...lockedExecutorUserIds],
    usersFilter: [],
    usersFilterInit: buildUsersInfoByIds(lockedExecutorUserIds),
    usersPager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
    usersInfo: buildUsersInfoByIds(lockedExecutorUserIds),
    name: getProcessDisplayName({
      ...item,
      templateId: selectedTemplateId,
    }),
    type: item.receiverTypeFilter,
    templateName:
      item.templateName ?? resolveProcessTemplateName(selectedTemplateId),
    isSigning: false,
    canDeny:
      typeof existingProcess?.canDeny === "boolean"
        ? existingProcess.canDeny
        : Boolean(item.canDeny),
    isLockedUsers: lockedExecutorUserIds.length > 0,
    lockedExecutorUserIds,
    errorMessage: "",
  };

  if (existingProcess) {
    applyProcessStateFromExisting(processItem, existingProcess);
  }

  syncProcessTemplateMeta(processItem);

  return processItem;
};

const applyProcessStateFromExisting = (target: any, process: any) => {
  target.position = process.position ?? target.position;
  target.templateId = process.templateId ?? target.templateId;
  target.isQueue =
    typeof process.isQueue === "boolean" ? process.isQueue : target.isQueue;
  target.comment = process.comment || "";
  target.users = (process.usersInfo || []).map(
    (userProcess: any) => userProcess.id
  );
  target.usersFilterInit = process.usersInfo || [];
  target.usersInfo = process.usersInfo || [];
  target.templateName = process.templateName ?? target.templateName;
  target.isSigning =
    typeof process.isSigning === "boolean"
      ? process.isSigning
      : target.isSigning;
  target.canDeny =
    typeof process.canDeny === "boolean" ? process.canDeny : target.canDeny;
  syncProcessTemplateMeta(target);
};

function createGuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const addFreeProcess = () => {
  const item = defaultFreeProcessConfig.value;
  if (!item) {
    return;
  }
  state.documentProcessesInfo.processList.push(
    createProcessListItem(item, true)
  );
};

const removeFreeProcess = (index: number) => {
  state.documentProcessesInfo.processList.splice(index, 1);
};

const userFilterRequestCache = new Map<string, Promise<any>>();

const getCachedProcessUserFilter = (data: Record<string, any>) => {
  const cacheKey = JSON.stringify({
    constructorId: data.constructorId,
    processGuid: data.processGuid,
    page: data.page,
    name: String(data.name || "")
      .trim()
      .toLowerCase(),
  });
  const cached = userFilterRequestCache.get(cacheKey);
  if (cached) {
    return cached;
  }
  const request = DocumentDataService.getProcessUserFilter(data).catch(
    (error) => {
      userFilterRequestCache.delete(cacheKey);
      throw error;
    }
  );
  userFilterRequestCache.set(cacheKey, request);
  return request;
};

const getFilterUser = async (
  guid: string,
  index: number,
  actionType: number,
  query = ""
) => {
  if (isUserSelectionLocked(state.documentProcessesInfo.processList[index])) {
    return;
  }
  if (actionType === getFilterUserActionTypes.SEARCH) {
    state.documentProcessesInfo.processList[index].usersPager!.currentPage = 1;
  }

  if (actionType === getFilterUserActionTypes.CLICK) {
    state.documentProcessesInfo.processList[index].usersPager!.currentPage = 1;
  }

  if (actionType === getFilterUserActionTypes.SCROLL) {
    state.documentProcessesInfo.processList[index].usersPager!.currentPage++;
  }

  let data = {
    constructorId: state.constructorId,
    processGuid: guid,
    page: state.documentProcessesInfo.processList[index].usersPager!
      .currentPage,
    name: query ? query : undefined,
  };

  try {
    await getCachedProcessUserFilter(data).then((response) => {
      const responseItems = response.data.data.items.map((item: any) => ({
        ...item,
      }));
      if (actionType === getFilterUserActionTypes.SCROLL) {
        let usersFilter: Array<any> = [];
        if (state.documentProcessesInfo.processList[index].usersFilter) {
          state.documentProcessesInfo.processList[index].usersFilter!.forEach(
            (item) => {
              usersFilter.push(item);
            }
          );
        }

        responseItems.forEach((item: any) => {
          usersFilter.push(item);
        });

        state.documentProcessesInfo.processList[index].usersFilter =
          usersFilter;
      }

      if (
        actionType === getFilterUserActionTypes.CLICK ||
        actionType === getFilterUserActionTypes.SEARCH
      ) {
        state.documentProcessesInfo.processList[index].usersFilter = [];

        state.documentProcessesInfo.processList[index].usersFilter = [
          ...responseItems,
        ];
      }

      state.documentProcessesInfo.processList[index].usersPager = {
        ...response.data.data.pager,
      };
    });
  } catch (error) {
    console.error(error);
  }
};

const isTemplate = ref(false);
const update = ref();

const mainFileError = ref("");
const subFileError = ref("");
const documentInfoPriceError = ref("");
const documentInfoDescriptionError = ref("");
const isSubmitting = ref(false);
function handleValidationErrors(errors: any) {
  if (errors["documentInfo.price"] !== undefined) {
    documentInfoPriceError.value = errors["documentInfo.price"];
  }

  if (errors["documentInfo.description"] !== undefined) {
    documentInfoDescriptionError.value = errors["documentInfo.description"];
  }

  if (errors["documentFilesErrors.mainFile"] !== undefined) {
    mainFileError.value = errors["documentFilesErrors.mainFile"];
  }

  if (errors["documentFilesErrors.subFile"] !== undefined) {
    subFileError.value = errors["documentFilesErrors.subFile"];
  }

  Object.entries(errors).forEach(([key, value]) => {
    const guid = key.substring(key.indexOf("[") + 1, key.lastIndexOf("]"));
    for (const process of state.documentProcessesInfo.processList) {
      if (process.constructorProcessGuid === guid) {
        process.errorMessage = value;
      }
    }
  });
}

const createDocument = async () => {
  await store
    .dispatch(DocumentActions.CREATE, state)
    .then(async (response) => {
      await router.push({
        name: "DocumentDetails",
        params: { id: response.documentId },
      });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
      handleValidationErrors(error.data.data);
    });
};

const updateDocument = async () => {
  await store
    .dispatch(DocumentActions.UPDATE, {
      id: route.params.id,
      data: state,
    })
    .then(async (response) => {
      await router.push({
        name: "DocumentDetails",
        params: { id: response.documentId },
      });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
      handleValidationErrors(error.data.data);
    });
};

watch(
  () => route.name,
  async () => {
    store.commit(DocumentMutations.SET_ONE, null);
  }
);

function formatDate(date: string) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

onMounted(async () => {
  await store.dispatch(DocumentConstructorActions.FETCH_ALL);
  constructors.value = store.getters[DocumentConstructorGetters.GET_ALL];

  await store.dispatch(NomenclatureActions.FETCH_ALL);
  nomenclatures.value = store.getters[NomenclatureGetters.GET_ALL] ?? [];
  users.value = (
    await DocumentConstructorDataService.getUsers()
  ).data.data.items;
  processTemplates.value = (
    await DocumentConstructorDataService.getTemplates()
  ).data.data.items;

  if (route.name === "DocumentEdit") {
    await store.dispatch(DocumentActions.FETCH_UPDATE_ONE, route.params.id);
    const document = store.getters[DocumentGetters.GET_CURRENT];

    state.id = document.id;
    state.constructorId = document.constructorInfo.id;
    state.documentFiles = document.documentFiles;

    state.documentInfo = document.documentInfo;
    state.documentInfo.nomenclature = document.documentInfo.nomenclatureInfo.id;
    state.documentInfo.counterpartyIds =
      document.documentInfo.counterpartyIds ?? [];
    state.documentInfo.esedoDocumentTypeId =
      document.documentInfo.esedoDocumentTypeId ?? null;
    state.documentInfo.esedoQuestionNatureId =
      document.documentInfo.esedoQuestionNatureId ?? null;

    update.value = document.documentProcessesInfo;
    await getInfoAndSetProcessList();

    if (document.documentProcessesInfo.deadline) {
      state.documentProcessesInfo.deadline = formatDate(
        document.documentProcessesInfo.deadline.split("+")[0]
      );
    }

    state.documentFiles.forEach(function (file) {
      let array = [];
      array.push(file.fileGuid);
      DocumentDataService.getFilesInfo(array).then((response) => {
        if (file.type === "MAIN") {
          mainFiles.value.push({
            guid: file.fileGuid,
            name: response.data[0].name + response.data[0].ext,
          });
        } else {
          attachedFiles.value.push({
            guid: file.fileGuid,
            name: response.data[0].name + response.data[0].ext,
          });
        }
      });
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _directive_auto_resize = _resolveDirective("auto-resize")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'DocumentList' },
      class: "mb-4"
    }),
    _createElementVNode("form", {
      onSubmit: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(route).name === "DocumentEdit"
              ? _ctx.$t("docForm.titleEdit")
              : _ctx.$t("docForm.titleCreate")), 1),
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("docForm.category")), 1),
          _withDirectives(_createElementVNode("select", {
            class: "input-form w-full",
            name: "constructor",
            id: "constructor",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).constructorId.$model) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (getInfoAndSetProcessList()))
          }, [
            _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t("docForm.selectCategory")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructors.value, (constructor) => {
              return (_openBlock(), _createElementBlock("option", {
                value: constructor.id,
                key: constructor.id
              }, _toDisplayString(constructor.name), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, _unref(v$).constructorId.$model]
          ])
        ]),
        (_unref(state).constructorId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("docForm.params")), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("label", {
                    for: "params-name",
                    class: _normalizeClass(["input-form-label mt-5", {
                'p-error': _unref(v$).documentInfo.title.$invalid && submitted.value,
              }])
                  }, _toDisplayString(_ctx.$t("docForm.theme")), 3),
                  (constructorInfo.value.params.title.isSelected)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        id: "params-name",
                        type: "text",
                        class: _normalizeClass(["input-form w-full", {
                'p-invalid': _unref(v$).documentInfo.title.$invalid && submitted.value,
              }]),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).documentInfo.title.$model) = $event))
                      }, null, 2)), [
                        [_vModelText, _unref(v$).documentInfo.title.$model]
                      ])
                    : _createCommentVNode("", true),
                  (_unref(v$).documentInfo.title.$externalResults.length > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref(v$).documentInfo.title.$externalResults[0].$message), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", {
                    for: "nomenclature",
                    class: _normalizeClass(["input-form-label mt-5", {
                'p-error': _unref(v$).documentInfo.nomenclature.$invalid && submitted.value,
              }])
                  }, _toDisplayString(_ctx.$t("docForm.nomenclature")), 3),
                  (constructorInfo.value.params.nomenclature.isSelected)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        id: "nomenclature",
                        class: _normalizeClass(["input-form w-full", {
                'p-invalid': _unref(v$).documentInfo.nomenclature.$invalid && submitted.value,
              }]),
                        name: "nomenclature",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).documentInfo.nomenclature.$model) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("docForm.selectNomenclature")), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nomenclatures.value, (nomenclature) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: nomenclature.id,
                            key: nomenclature.id
                          }, _toDisplayString(nomenclature.name), 9, _hoisted_12))
                        }), 128))
                      ], 2)), [
                        [_vModelSelect, _unref(v$).documentInfo.nomenclature.$model]
                      ])
                    : _createCommentVNode("", true)
                ]),
                (constructorInfo.value.params.price.isSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("label", {
                        for: "params-price",
                        class: _normalizeClass(["input-form-label mt-5", {
                'p-error': _unref(v$).documentInfo.price.$invalid && submitted.value,
              }])
                      }, _toDisplayString(_ctx.$t("docForm.price")), 3),
                      _withDirectives(_createElementVNode("input", {
                        id: "params-price",
                        type: "text",
                        class: _normalizeClass(["input-form w-full", {
                'p-invalid': _unref(v$).documentInfo.price.$invalid && submitted.value,
              }]),
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (documentInfoPriceError.value = '')),
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).documentInfo.price.$model) = $event))
                      }, null, 34), [
                        [_vModelText, _unref(v$).documentInfo.price.$model]
                      ]),
                      (documentInfoPriceError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(documentInfoPriceError.value), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (constructorInfo.value.params.description.isSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("label", {
                        for: "params-description",
                        class: _normalizeClass(["input-form-label mt-5", {
                'p-error': _unref(v$).documentInfo.description.$invalid && submitted.value,
              }])
                      }, _toDisplayString(_ctx.$t("docForm.description")), 3),
                      _withDirectives(_createElementVNode("textarea", {
                        id: "params-description",
                        class: _normalizeClass(["input-form w-full", {
                'p-invalid': _unref(v$).documentInfo.description.$invalid && submitted.value,
              }]),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (documentInfoDescriptionError.value = '')),
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).documentInfo.description.$model) = $event))
                      }, null, 34), [
                        [_vModelText, _unref(v$).documentInfo.description.$model]
                      ]),
                      (documentInfoDescriptionError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(documentInfoDescriptionError.value), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(esedoEnabled))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t("esedo.title")), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("esedo.documentType")), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "esedo-document-type",
                          class: "input-form w-full",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).documentInfo.esedoDocumentTypeId) = $event))
                        }, [
                          _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("common.notSelected")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(esedoDocumentTypes), (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.id,
                              value: item.id
                            }, _toDisplayString(item.name), 9, _hoisted_21))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _unref(state).documentInfo.esedoDocumentTypeId]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("esedo.questionNature")), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "esedo-question-nature",
                          class: "input-form w-full",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).documentInfo.esedoQuestionNatureId) = $event))
                        }, [
                          _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("common.notSelected")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(esedoQuestionNatures), (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.id,
                              value: item.id
                            }, _toDisplayString(item.name), 9, _hoisted_24))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _unref(state).documentInfo.esedoQuestionNatureId]
                        ])
                      ]),
                      (_unref(showCounterparties))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("label", _hoisted_26, [
                              _createTextVNode(_toDisplayString(_ctx.$t("esedo.partners")) + " ", 1),
                              (_unref(counterpartyRequired))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_unref(Multiselect), {
                              id: "esedo-partners",
                              modelValue: _unref(state).documentInfo.counterpartyIds,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).documentInfo.counterpartyIds) = $event)),
                              options: _unref(esedoPartners),
                              mode: "tags",
                              object: false,
                              "value-prop": "id",
                              label: "name",
                              placeholder: _ctx.$t('esedo.selectPartners')
                            }, null, 8, ["modelValue", "options", "placeholder"]),
                            (counterpartyError.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(counterpartyError.value), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (constructorInfo.value.params.mainFile.isSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("h2", _hoisted_30, _toDisplayString(_ctx.$t("docForm.mainFile")), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["document-source-tab", { active: !isTemplate.value }]),
                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (setDocumentSourceMode(false)), ["prevent"]))
                      }, _toDisplayString(_ctx.$t("docForm.uploadTab")), 3),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["document-source-tab", { active: isTemplate.value }]),
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (setDocumentSourceMode(true)), ["prevent"]))
                      }, _toDisplayString(_ctx.$t("docForm.generateTab")), 3)
                    ]),
                    (isTemplate.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (!convertedFile.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                (!showFilledPreview.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("docForm.mainFileSelectTemplate")), 1),
                                      _createElementVNode("div", null, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: "input-form w-full",
                                          id: "template",
                                          name: "template",
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((templateFile.value.templateId) = $event)),
                                          onChange: loadSelectedTemplateConfig
                                        }, [
                                          _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.$t("common.notSelected")), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableDocumentTemplates), (template) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              value: template.id,
                                              key: template.id
                                            }, _toDisplayString(template.name), 9, _hoisted_35))
                                          }), 128))
                                        ], 544), [
                                          [_vModelSelect, templateFile.value.templateId]
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("label", {
                                          class: _normalizeClass(["input-form-label mt-5", {
                    'p-error': templateFile.value.errorMessage,
                  }])
                                        }, _toDisplayString(_ctx.$t("docForm.fileName")), 3),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: _normalizeClass(["input-form w-full", {
                    'p-invalid': templateFile.value.errorMessage,
                  }]),
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((templateFile.value.name) = $event)),
                                          onChange: _cache[15] || (_cache[15] = ($event: any) => (templateFile.value.errorMessage = ''))
                                        }, null, 34), [
                                          [_vModelText, templateFile.value.name]
                                        ]),
                                        (templateFile.value.errorMessage)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(templateFile.value.errorMessage), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.$t("docForm.previewFilledTitle")), 1),
                                      _createVNode(_unref(Editor), {
                                        class: "editor my-4",
                                        disabled: false,
                                        id: "filled-preview",
                                        init: _unref(fullTinyMceConfig),
                                        "tinymce-script-src": _unref(tinyMceScriptSrc),
                                        inline: false,
                                        modelValue: filledPreviewHtml.value,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((filledPreviewHtml).value = $event)),
                                        onChange: markFilledPreviewAsEdited
                                      }, null, 8, ["init", "tinymce-script-src", "modelValue"])
                                    ])),
                                (templateFile.value.manualFields.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _createElementVNode("h3", _hoisted_40, _toDisplayString(_ctx.$t("docTemplate.manualFields.title")), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateFile.value.manualFields, (field) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: field.tag
                                        }, [
                                          _createElementVNode("label", _hoisted_41, [
                                            _createTextVNode(_toDisplayString(field.name) + " ", 1),
                                            (field.required)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, "*"))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (field.type === 'TEXTAREA')
                                            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                key: 0,
                                                class: "input-form w-full",
                                                rows: "3",
                                                "onUpdate:modelValue": ($event: any) => ((templateFile.value.manualFieldValues[field.tag]) = $event)
                                              }, null, 8, _hoisted_43)), [
                                                [_vModelText, templateFile.value.manualFieldValues[field.tag]]
                                              ])
                                            : (field.type === 'DATE')
                                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                  key: 1,
                                                  type: "date",
                                                  class: "input-form w-full",
                                                  "onUpdate:modelValue": ($event: any) => ((templateFile.value.manualFieldValues[field.tag]) = $event)
                                                }, null, 8, _hoisted_44)), [
                                                  [_vModelText, templateFile.value.manualFieldValues[field.tag]]
                                                ])
                                              : (field.type === 'DATETIME')
                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                    key: 2,
                                                    type: "datetime-local",
                                                    class: "input-form w-full",
                                                    "onUpdate:modelValue": ($event: any) => ((templateFile.value.manualFieldValues[field.tag]) = $event)
                                                  }, null, 8, _hoisted_45)), [
                                                    [_vModelText, templateFile.value.manualFieldValues[field.tag]]
                                                  ])
                                                : (field.type === 'SELECT')
                                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                      key: 3,
                                                      class: "input-form w-full",
                                                      "onUpdate:modelValue": ($event: any) => ((templateFile.value.manualFieldValues[field.tag]) = $event)
                                                    }, [
                                                      _createElementVNode("option", _hoisted_47, _toDisplayString(_ctx.$t("common.notSelected")), 1),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                          key: option.value,
                                                          value: option.value
                                                        }, _toDisplayString(option.label), 9, _hoisted_48))
                                                      }), 128))
                                                    ], 8, _hoisted_46)), [
                                                      [_vModelSelect, templateFile.value.manualFieldValues[field.tag]]
                                                    ])
                                                  : (field.type === 'MULTI_SELECT')
                                                    ? (_openBlock(), _createBlock(_unref(Multiselect), {
                                                        key: 4,
                                                        modelValue: templateFile.value.manualFieldValues[field.tag],
                                                        "onUpdate:modelValue": ($event: any) => ((templateFile.value.manualFieldValues[field.tag]) = $event),
                                                        options: field.options,
                                                        mode: "tags",
                                                        object: false,
                                                        "value-prop": "value",
                                                        label: "label"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                                    : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                        key: 5,
                                                        class: "input-form w-full",
                                                        rows: "3",
                                                        "onUpdate:modelValue": ($event: any) => ((templateFile.value.manualFieldValues[field.tag]) = $event)
                                                      }, null, 8, _hoisted_49)), [
                                                        [_vModelText, templateFile.value.manualFieldValues[field.tag]]
                                                      ]),
                                          (templateFile.value.manualFieldErrors[field.tag])
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(templateFile.value.manualFieldErrors[field.tag]), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_51, [
                                  (showFilledPreview.value)
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        variant: "default",
                                        onClick: _withModifiers(backToTemplateFields, ["prevent"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("docForm.backToFields")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (templateFile.value.templateId)
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 1,
                                        variant: "default",
                                        onClick: _withModifiers(openFilledTemplatePreview, ["prevent"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("docForm.previewFilledTemplate")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_Button, {
                                    onClick: _withModifiers(uploadTemplate, ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("docForm.confirm")), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_unref(mainFiles).length)
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainFiles), (file, index) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: file.name,
                                    class: "border border-gray-100 p-2 px-4 rounded-lg flex flex-wrap items-center gap-4"
                                  }, [
                                    _createVNode(_unref(CheckCircleIcon), { class: "w-10 h-10 text-green-500" }),
                                    _createTextVNode(" " + _toDisplayString(file.name) + " ", 1),
                                    (editableSourceFor(file.guid))
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          variant: "default",
                                          onClick: _withModifiers(($event: any) => (editGeneratedMainFile(file.guid)), ["prevent"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    (fileEditChangesFor(file.guid))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          type: "button",
                                          class: "rounded-full bg-amber-100 px-3 py-1 text-sm font-medium text-amber-800 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1",
                                          onClick: _withModifiers(($event: any) => (openFileEditChanges(file.guid)), ["prevent","stop"])
                                        }, _toDisplayString(_ctx.$t("docForm.editedBadge")), 9, _hoisted_53))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      class: "cursor-pointer m-2 p-2 rounded-lg bg-red-100 text-red-500",
                                      onClick: ($event: any) => (deleteMainFile(index, file.guid))
                                    }, [
                                      _createVNode(_unref(TrashIcon), { class: "inline w-6 h-6 text-red-500" }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t("docForm.delete")), 1)
                                    ], 8, _hoisted_54)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_unref(mainFiles).length === 0)
                            ? (_openBlock(), _createBlock(DocumentUploadZone, {
                                key: 0,
                                onFilesSelected: _cache[17] || (_cache[17] = ($event: any) => (uploadMainFile('MAIN', $event)))
                              }))
                            : _createCommentVNode("", true),
                          (mainFileError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(mainFileError.value), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("ul", _hoisted_56, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainFiles), (file, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: file.name,
                                class: "border border-gray-100 p-2 px-4 rounded-lg flex flex-wrap items-center gap-4"
                              }, [
                                _createVNode(_unref(DocumentDownloadIcon), {
                                  class: "w-10 h-10 text-green-500 cursor-pointer",
                                  onClick: ($event: any) => (downloadFile(file.guid, file.name))
                                }, null, 8, ["onClick"]),
                                _createVNode(_unref(CheckCircleIcon), { class: "w-10 h-10 text-green-500" }),
                                _createTextVNode(" " + _toDisplayString(file.name) + " ", 1),
                                (editableSourceFor(file.guid))
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      variant: "default",
                                      onClick: _withModifiers(($event: any) => (editGeneratedMainFile(file.guid)), ["prevent"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (fileEditChangesFor(file.guid))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "rounded-full bg-amber-100 px-3 py-1 text-sm font-medium text-amber-800 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1",
                                      onClick: _withModifiers(($event: any) => (openFileEditChanges(file.guid)), ["prevent","stop"])
                                    }, _toDisplayString(_ctx.$t("docForm.editedBadge")), 9, _hoisted_57))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: "cursor-pointer m-2 p-2 rounded-lg bg-red-100 text-red-500",
                                  onClick: ($event: any) => (deleteMainFile(index, file.guid))
                                }, [
                                  _createVNode(_unref(TrashIcon), { class: "inline w-6 h-6 text-red-500" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("docForm.delete")), 1)
                                ], 8, _hoisted_58)
                              ]))
                            }), 128))
                          ])
                        ], 64))
                  ]))
                : _createCommentVNode("", true),
              (constructorInfo.value.params.subFile.isSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("h2", _hoisted_60, _toDisplayString(_ctx.$t("docForm.extraFiles")), 1),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["document-source-tab", { active: !isSubTemplate.value }]),
                        onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (setSubDocumentSourceMode(false)), ["prevent"]))
                      }, _toDisplayString(_ctx.$t("docForm.uploadTab")), 3),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["document-source-tab", { active: isSubTemplate.value }]),
                        onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (setSubDocumentSourceMode(true)), ["prevent"]))
                      }, _toDisplayString(_ctx.$t("docForm.generateTab")), 3)
                    ]),
                    (isSubTemplate.value && subTemplateFile.value.templateId)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "mx-4",
                          onClick: _withModifiers(toggleSubTemplatePreview, ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(!showSubTemplate.value
                ? _ctx.$t("docForm.previewTemplate")
                : _ctx.$t("docForm.hideTemplate")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (isSubTemplate.value && showSubTemplate.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createVNode(_unref(Editor), {
                            class: "editor my-10",
                            disabled: false,
                            id: "additional-template-editor",
                            init: _unref(fullTinyMceConfig),
                            "tinymce-script-src": _unref(tinyMceScriptSrc),
                            inline: false,
                            "tag-name": "div",
                            modelValue: subTemplateFile.value.template,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((subTemplateFile.value.template) = $event)),
                            onChange: markSubPreviewAsEdited
                          }, null, 8, ["init", "tinymce-script-src", "modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    (isSubTemplate.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("docForm.mainFileSelectTemplate")), 1),
                            _withDirectives(_createElementVNode("select", {
                              class: "input-form w-full",
                              id: "additional-template",
                              name: "additional-template",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((subTemplateFile.value.templateId) = $event)),
                              onChange: loadSelectedSubTemplateConfig
                            }, [
                              _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.$t("common.notSelected")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableDocumentTemplates), (template) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: template.id,
                                  key: template.id
                                }, _toDisplayString(template.name), 9, _hoisted_66))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, subTemplateFile.value.templateId]
                            ]),
                            (subTemplateFile.value.templateError)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(subTemplateFile.value.templateError), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("docForm.fileName")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: _normalizeClass(["input-form w-full", {
                  'p-invalid': subTemplateFile.value.errorMessage,
                }]),
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((subTemplateFile.value.name) = $event)),
                              onChange: _cache[23] || (_cache[23] = ($event: any) => (subTemplateFile.value.errorMessage = ''))
                            }, null, 34), [
                              [_vModelText, subTemplateFile.value.name]
                            ]),
                            (subTemplateFile.value.errorMessage)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(subTemplateFile.value.errorMessage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (subTemplateFile.value.manualFields.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _createElementVNode("h3", _hoisted_71, _toDisplayString(_ctx.$t("docTemplate.manualFields.title")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTemplateFile.value.manualFields, (field) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: field.tag
                                  }, [
                                    _createElementVNode("label", _hoisted_72, [
                                      _createTextVNode(_toDisplayString(field.name) + " ", 1),
                                      (field.required)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_73, "*"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (field.type === 'TEXTAREA')
                                      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: 0,
                                          class: "input-form w-full",
                                          rows: "3",
                                          "onUpdate:modelValue": ($event: any) => ((subTemplateFile.value.manualFieldValues[field.tag]) = $event)
                                        }, null, 8, _hoisted_74)), [
                                          [_vModelText, subTemplateFile.value.manualFieldValues[field.tag]]
                                        ])
                                      : (field.type === 'DATE')
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 1,
                                            type: "date",
                                            class: "input-form w-full",
                                            "onUpdate:modelValue": ($event: any) => ((subTemplateFile.value.manualFieldValues[field.tag]) = $event)
                                          }, null, 8, _hoisted_75)), [
                                            [_vModelText, subTemplateFile.value.manualFieldValues[field.tag]]
                                          ])
                                        : (field.type === 'DATETIME')
                                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                              key: 2,
                                              type: "datetime-local",
                                              class: "input-form w-full",
                                              "onUpdate:modelValue": ($event: any) => ((subTemplateFile.value.manualFieldValues[field.tag]) = $event)
                                            }, null, 8, _hoisted_76)), [
                                              [_vModelText, subTemplateFile.value.manualFieldValues[field.tag]]
                                            ])
                                          : (field.type === 'SELECT')
                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                key: 3,
                                                class: "input-form w-full",
                                                "onUpdate:modelValue": ($event: any) => ((subTemplateFile.value.manualFieldValues[field.tag]) = $event)
                                              }, [
                                                _createElementVNode("option", _hoisted_78, _toDisplayString(_ctx.$t("common.notSelected")), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    key: option.value,
                                                    value: option.value
                                                  }, _toDisplayString(option.label), 9, _hoisted_79))
                                                }), 128))
                                              ], 8, _hoisted_77)), [
                                                [_vModelSelect, subTemplateFile.value.manualFieldValues[field.tag]]
                                              ])
                                            : (field.type === 'MULTI_SELECT')
                                              ? (_openBlock(), _createBlock(_unref(Multiselect), {
                                                  key: 4,
                                                  modelValue: subTemplateFile.value.manualFieldValues[field.tag],
                                                  "onUpdate:modelValue": ($event: any) => ((subTemplateFile.value.manualFieldValues[field.tag]) = $event),
                                                  options: field.options,
                                                  mode: "tags",
                                                  object: false,
                                                  "value-prop": "value",
                                                  label: "label"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                  key: 5,
                                                  class: "input-form w-full",
                                                  rows: "3",
                                                  "onUpdate:modelValue": ($event: any) => ((subTemplateFile.value.manualFieldValues[field.tag]) = $event)
                                                }, null, 8, _hoisted_80)), [
                                                  [_vModelText, subTemplateFile.value.manualFieldValues[field.tag]]
                                                ]),
                                    (subTemplateFile.value.manualFieldErrors[field.tag])
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_81, _toDisplayString(subTemplateFile.value.manualFieldErrors[field.tag]), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_82, [
                            (editingSubFileGuid.value && showSubTemplate.value)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  variant: "default",
                                  onClick: _withModifiers(refreshEditedSubPreview, ["prevent"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("docForm.previewFilledTemplate")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_Button, {
                              onClick: _withModifiers(uploadSubTemplate, ["prevent"]),
                              disabled: isGeneratingSubTemplate.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("docForm.generateAdditionalFile")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ])
                        ]))
                      : (_openBlock(), _createBlock(DocumentUploadZone, {
                          key: 3,
                          multiple: "",
                          onFilesSelected: _cache[24] || (_cache[24] = ($event: any) => (uploadFile('SUB', $event)))
                        })),
                    (subFileError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(subFileError.value), 1))
                      : _createCommentVNode("", true),
                    (_unref(attachedFiles))
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_84, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachedFiles), (file, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: file.guid,
                              class: "border border-gray-100 p-2 px-4 rounded-lg flex flex-wrap items-center gap-4"
                            }, [
                              _createVNode(_unref(DocumentDownloadIcon), {
                                class: "w-10 h-10 text-green-500 cursor-pointer",
                                onClick: ($event: any) => (downloadFile(file.guid, file.name))
                              }, null, 8, ["onClick"]),
                              _createVNode(_unref(CheckCircleIcon), { class: "w-10 h-10 text-green-500" }),
                              _createTextVNode(" " + _toDisplayString(file.name) + " ", 1),
                              (editableSourceFor(file.guid))
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    variant: "default",
                                    onClick: _withModifiers(($event: any) => (editGeneratedSubFile(file.guid)), ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (fileEditChangesFor(file.guid))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "rounded-full bg-amber-100 px-3 py-1 text-sm font-medium text-amber-800 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1",
                                    onClick: _withModifiers(($event: any) => (openFileEditChanges(file.guid)), ["prevent","stop"])
                                  }, _toDisplayString(_ctx.$t("docForm.editedBadge")), 9, _hoisted_85))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "cursor-pointer m-2 p-2 rounded-lg bg-red-100 text-red-500",
                                onClick: ($event: any) => (deleteSubFile(index, file.guid))
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "inline w-6 h-6 text-red-500" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("docForm.delete")), 1)
                              ], 8, _hoisted_86)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("h2", _hoisted_88, _toDisplayString(_ctx.$t("docForm.processList")), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("label", {
                    class: _normalizeClass(["input-form-label", {
                'p-error':
                  _unref(v$).documentProcessesInfo.deadline.$invalid && submitted.value,
              }])
                  }, _toDisplayString(_ctx.$t("docForm.deadline")), 3),
                  _createVNode(_component_Datepicker, {
                    class: _normalizeClass({
                'p-invalid':
                  _unref(v$).documentProcessesInfo.deadline.$invalid && submitted.value,
              }),
                    locale: "ru",
                    selectText: _ctx.$t('docForm.apply'),
                    cancelText: _ctx.$t('docForm.cancel'),
                    placeholder: _ctx.$t('docForm.datePlaceholder'),
                    enableTimePicker: false,
                    modelValue: _unref(v$).documentProcessesInfo.deadline.$model,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(v$).documentProcessesInfo.deadline.$model) = $event)),
                    format: "dd/MM/yyyy",
                    previewFormat: "dd/MM/yyyy",
                    autoApply: true,
                    minDate: new Date()
                  }, null, 8, ["class", "selectText", "cancelText", "placeholder", "modelValue", "minDate"])
                ])
              ]),
              (constructorInfo.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                    (_unref(freeProcessOptions).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                          _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.$t("docForm.freeProcessHint")), 1),
                          _createVNode(_component_Button, {
                            type: "button",
                            onClick: _withModifiers(addFreeProcess, ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("docForm.addFreeProcess")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).documentProcessesInfo.processList, (process, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: process.instanceGuid || process.constructorProcessGuid,
                        class: "card-global mb-8 text-gray-800"
                      }, [
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("h2", _hoisted_93, _toDisplayString(_ctx.$t("docForm.process")) + " " + _toDisplayString(index + 1), 1),
                          (process.isFreeInstance)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "p-2 rounded border border-red-300 text-red-600",
                                onClick: _withModifiers(($event: any) => (removeFreeProcess(index)), ["prevent"])
                              }, [
                                _createVNode(_unref(XIcon), { class: "w-5 h-5" })
                              ], 8, _hoisted_94))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.$t("docForm.processType")), 1),
                            (process.isFreeInstance)
                              ? (_openBlock(), _createBlock(_unref(Multiselect), {
                                  key: 0,
                                  modelValue: process.templateId,
                                  "onUpdate:modelValue": ($event: any) => ((process.templateId) = $event),
                                  options: getAvailableTemplateOptions(process),
                                  placeholder: _ctx.$t('docForm.selectProcessType'),
                                  valueProp: "value",
                                  "track-by": "label",
                                  label: "label",
                                  onChange: ($event: any) => (syncProcessTemplateMeta(process))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "onChange"]))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  type: "text",
                                  disabled: "",
                                  value: 
                    process.templateName ||
                    resolveProcessTemplateName(process.templateId)
                  ,
                                  class: "input-form w-full"
                                }, null, 8, _hoisted_97))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("docForm.executionType")), 1),
                            (process.isFreeInstance)
                              ? (_openBlock(), _createBlock(_unref(Multiselect), {
                                  key: 0,
                                  modelValue: process.isQueue,
                                  "onUpdate:modelValue": ($event: any) => ((process.isQueue) = $event),
                                  options: executionModeOptions,
                                  valueProp: "value",
                                  "track-by": "label",
                                  label: "label"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  type: "text",
                                  disabled: "",
                                  value: 
                    process.isQueue
                      ? _ctx.$t('docForm.serialExecution')
                      : _ctx.$t('docForm.parallelExecution')
                  ,
                                  class: "input-form w-full"
                                }, null, 8, _hoisted_99))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", {
                            class: _normalizeClass(["input-form-label mt-5", { 'p-error': process.errorMessage }])
                          }, _toDisplayString(_ctx.$t("docForm.receivers")), 3),
                          (isUserSelectionLocked(process))
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                disabled: "",
                                value: getLockedUsersLabel(process),
                                class: "input-form w-full"
                              }, null, 8, _hoisted_100))
                            : (_openBlock(), _createBlock(CustomMultiSelect, {
                                key: 1,
                                modelValue: process.users,
                                "onUpdate:modelValue": ($event: any) => ((process.users) = $event),
                                options: process.usersFilter,
                                "options-init": process.usersFilterInit,
                                isMoreOptions: 
                  process.usersPager.totalPages > process.usersPager.currentPage
                ,
                                valueProp: "id",
                                "track-by": "fullName",
                                onClick: ($event: any) => (
                  process.usersFilter.length <= 0
                    ? getFilterUser(
                        process.constructorProcessGuid,
                        index,
                        getFilterUserActionTypes.CLICK
                      )
                    : undefined
                ),
                                onReachedEnd: ($event: any) => (
                  getFilterUser(
                    process.constructorProcessGuid,
                    index,
                    getFilterUserActionTypes.SCROLL,
                    $event
                  )
                ),
                                onSearchChange: 
                  ($event) =>
                    getFilterUser(
                      process.constructorProcessGuid,
                      index,
                      getFilterUserActionTypes.SEARCH,
                      $event
                    )
                
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "options-init", "isMoreOptions", "onClick", "onReachedEnd", "onSearchChange"])),
                          (process.errorMessage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(process.errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.$t("docForm.comment")), 1),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((process.comment) = $event),
                            class: "input-form w-full"
                          }, null, 8, _hoisted_103), [
                            [_directive_auto_resize],
                            [_vModelText, process.comment]
                          ])
                        ]),
                        (process.isFreeInstance)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_104, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((process.canDeny) = $event),
                                class: "rounded border-gray-300 text-primary-300 focus:ring-primary-300"
                              }, null, 8, _hoisted_105), [
                                [_vModelCheckbox, process.canDeny]
                              ]),
                              _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$t("docForm.executorCanDeny")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  type: "submit",
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$route.name === "DocumentEdit"
                ? _ctx.$t("docForm.submitUpdate")
                : _ctx.$t("docForm.submitCreate")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 32),
    _createVNode(Modal, {
      show: Boolean(selectedFileEditChanges.value),
      title: _ctx.$t('docForm.editedDetailsTitle'),
      onClose: closeFileEditChanges
    }, {
      default: _withCtx(() => [
        (selectedFileEditChanges.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
              (selectedFileEditChanges.value.manualTextChanged)
                ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(_ctx.$t("docForm.manualTextChanged")), 1))
                : _createCommentVNode("", true),
              (selectedFileEditChanges.value.fieldChanges.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                    _createElementVNode("p", _hoisted_110, _toDisplayString(_ctx.$t("docForm.changedFields")), 1),
                    _createElementVNode("ul", _hoisted_111, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFileEditChanges.value.fieldChanges, (change) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: change.tag,
                          class: "px-4 py-3"
                        }, [
                          _createElementVNode("p", _hoisted_112, _toDisplayString(change.label), 1),
                          _createElementVNode("p", _hoisted_113, [
                            _createElementVNode("span", _hoisted_114, _toDisplayString(change.before), 1),
                            _hoisted_115,
                            _createElementVNode("span", _hoisted_116, _toDisplayString(change.after), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "title"]),
    _createVNode(Modal, {
      show: showFilledPreviewConflictModal.value,
      title: _ctx.$t('docForm.previewConflictTitle'),
      onClose: _cache[29] || (_cache[29] = ($event: any) => (resolveFilledPreviewConflict(null)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_117, _toDisplayString(_ctx.$t("docForm.previewConflictMessage")), 1),
        _createElementVNode("p", _hoisted_118, _toDisplayString(_ctx.$t("docForm.previewConflictHint")), 1),
        _createElementVNode("div", _hoisted_119, [
          _createVNode(_component_Button, {
            type: "button",
            variant: "default",
            onClick: _cache[27] || (_cache[27] = ($event: any) => (resolveFilledPreviewConflict('KEEP')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("docForm.previewConflictKeep")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "button",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (resolveFilledPreviewConflict('REBUILD')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("docForm.previewConflictRebuild")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "title"]),
    _createVNode(Modal, {
      show: showLeaveModal.value,
      title: _ctx.$t('docForm.leaveTitle'),
      onClose: stayOnCreatePage
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_120, _toDisplayString(_ctx.$t("docForm.leaveMessage")), 1),
        _createElementVNode("div", _hoisted_121, [
          _createVNode(_component_Button, {
            type: "button",
            variant: "default",
            onClick: stayOnCreatePage
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("docForm.leaveStay")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            type: "button",
            onClick: confirmLeaveCreatePage
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("docForm.leaveConfirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})